import {Locales} from '@netx/core-next/locales/utils/Locales';

export const AssetCustomThumbnailActionLabel = Locales((i18n) => ({
	SELECT: i18n('i18n.addCustomThumbnail'),
	SUBMIT: i18n('i18n.save'),
}));

export const AssetCustomThumbnailMessage = Locales((i18n) => ({
	UPDATING: i18n('i18n.settingCustomThumbnail'),
	UPDATE_FAILED: i18n('i18n.assetCustomThumbnailFailed'),
	ALREADY_UPDATING: i18n('i18n.fileInProgress'),
}));

export const AssetCustomThumbnailTitle = Locales((i18n) => ({
	IMPORT: i18n('i18n.addCustomThumbnail'),
}));
